import {
    createColumnHelper,
} from '@tanstack/react-table';

const columnHelper = createColumnHelper();

const columns = (t) => {
    return [
        columnHelper.accessor("invoiceNumber", {
            header: () => <span>{t("costReport.invoiceNumber")}</span>,
        }),
        columnHelper.accessor("storeCostcenter", {
            header: () => <span>{t("costReport.storeCostcenter")}</span>,
        }),
        columnHelper.accessor("storeName", {
            header: () => <span>{t("costReport.storeName")}</span>,
        }),
        columnHelper.accessor("company", {
            header: () => <span>{t("costReport.company")}</span>,
        }),
        columnHelper.accessor("supplierCompanyName", {
            header: () => <span>{t("costReport.supplierCompanyName")}</span>,
        }),
        columnHelper.accessor("taxFolio", {
            header: () => <span>{t("costReport.taxFolio")}</span>,
        }),
        columnHelper.accessor("invoiceDate", {
            header: () => <span>{t("costReport.invoiceDate")}</span>
        }),
        columnHelper.accessor("subTotal", {
            header: () => <span>{t("costReport.subTotal")}</span>,
            cell: (info) => `$${info.getValue().toLocaleString()}`,
        }),
        columnHelper.accessor("dayCost", {
            header: () => <span>{t("costReport.dayCost")}</span>,
            cell: (info) => `$${info.getValue().toLocaleString()}`,
        }),
        columnHelper.accessor("iva", {
            header: () => <span>{t("costReport.iva")}</span>,
            cell: (info) => `$${info.getValue().toLocaleString()}`,
        }),
        columnHelper.accessor("total", {
            header: () => <span>{t("costReport.total")}</span>,
            cell: (info) => `$${info.getValue().toLocaleString()}`,
        }),
        columnHelper.accessor("totalDaysWorked", {
            header: () => <span>{t("costReport.totalDaysWorked")}</span>
        }),
        columnHelper.accessor("additionalServices", {
            header: () => <span>{t("costReport.additionalServices")}</span>
        })
    ];
};

export default columns;